/* REPORT DETAIL*/
export const POST_BIRTH_DETAILS_INPUT = "POST_BIRTH_DETAILS_INPUT"
export const POST_BIRTH_DETAILS_INPUT_SUCCESS = "POST_BIRTH_DETAILS_INPUT_SUCCESS"
export const POST_BIRTH_DETAILS_INPUT_FAIL = "POST_BIRTH_DETAILS_INPUT_FAIL"
export const GET_BIRTH_CHART_LIST = "GET_BIRTH_CHART_LIST"
export const GET_BIRTH_CHART_LIST_SUCCESS = "GET_BIRTH_CHART_LIST_SUCCESS"
export const GET_BIRTH_CHART_LIST_FAIL = "GET_BIRTH_CHART_LIST_FAIL"
export const GET_BIRTH_CHART = "GET_BIRTH_CHART"
export const GET_BIRTH_CHART_SUCCESS = "GET_BIRTH_CHART_SUCCESS"
export const GET_BIRTH_CHART_FAIL = "GET_BIRTH_CHART_FAIL"
export const GET_PLACES = "GET_PLACES"
export const GET_PLACES_SUCCESS = "GET_PLACES_SUCCESS"
export const CLEAR_PLACES = "CLEAR_PLACES"
export const GET_PLACES_FAIL = "GET_PLACES_FAIL"
export const SET_PLACE_KEYWORD = "SET_PLACE_KEYWORD_SUCCESS"
export const CLEAR_PLACE_KEYWORD = "CLEAR_PLACE_KEYWORD_SUCCESS"
export const GET_BIRTH_CHART_PDF = "GET_BIRTH_CHART"
export const GET_BIRTH_CHART_PDF_SUCCESS = "GET_BIRTH_CHART_SUCCESS"
export const GET_BIRTH_CHART_PDF_FAIL = "GET_BIRTH_CHART_FAIL"

export const GET_PLACES_API_TOKEN = "GET_PLACES_API_TOKEN"
export const GET_PLACES_API_TOKEN_SUCCESS = "GET_PLACES_API_TOKEN_SUCCESS"
export const CLEAR_PLACES_API_TOKEN = "CLEAR_PLACES_API_TOKEN"
export const GET_PLACES_API_TOKEN_FAIL = "GET_PLACES_API_TOKEN_FAIL"


export const CREATE_PAYPAL_ORDER = "CREATE_PAYPAL_ORDER"
export const CREATE_PAYPAL_ORDER_SUCCESS = "CREATE_PAYPAL_ORDER_SUCCESS"
export const CREATE_PAYPAL_ORDER_FAIL = "CREATE_PAYPAL_ORDER_FAIL"

export const APPROVE_PAYPAL_ORDER = "APPROVE_PAYPAL_ORDER"
export const APPROVE_PAYPAL_ORDER_SUCCESS = "APPROVE_PAYPAL_ORDER_SUCCESS"
export const APPROVE_PAYPAL_ORDER_FAIL = "APPROVE_PAYPAL_ORDER_FAIL"

export const REPORT_ORDER_CONFIRMATION = "REPORT_ORDER_CONFIRMATION"
export const REPORT_ORDER_CONFIRMATION_SUCCESS = "REPORT_ORDER_CONFIRMATION_SUCCESS"
export const REPORT_ORDER_CONFIRMATION_FAIL = "REPORT_ORDER_CONFIRMATION_FAIL"


